import React, { useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "../../ui/dialog";
import Button from "../../form/button";

interface AccountcreatedProps {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}
export default function AccountCreated({ open, setOpen }: AccountcreatedProps) {
    return (
        <Dialog open={open} onOpenChange={setOpen}>
            <DialogContent className="mt-8 md:mt-0">
                <DialogHeader>
                    <DialogTitle>Account created!</DialogTitle>
                    <DialogDescription>Your account has been successfully created.</DialogDescription>
                </DialogHeader>
                <p className="text-sm">We have send a mail to verify your e-mailadres. After you have verified your mail, you need to ask Rein to grant you access to the platform.</p>
                <DialogFooter className="mt-4 gap-2">
                    <Button onClick={() => setOpen(false)}>Close</Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
